module.exports = __webpack_public_path__ + "img/luban2.a3c358c4.png";